/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const NoticeRouter = {
  path: '/notice',
  name: 'notice',
  redirect: { name: 'notice-aftersale-settlement' },
  component: () => import('@/views/notice/index.vue'),
  children: [
    {
      path: 'aftersale-settlement',
      name: 'notice-aftersale-settlement',
      component: () =>
        import(/* webpackChunkName: "jijia" */ '@/views/notice/aftersale-settlement.vue'),
    },
  ],
}
export default NoticeRouter
